import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=10368adc&scoped=true&"
import script from "./VehicleView.vue?vue&type=script&lang=js&"
export * from "./VehicleView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VehicleView.vue?vue&type=style&index=1&id=10368adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10368adc",
  null
  
)

export default component.exports